import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { combineLatest, Observable, Subject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';
import { CookieService } from './cookie.service';
import { Store } from '@ngrx/store';
import { AppStateInterface } from '../../store/state/app.state';
import {
  emailSelector,
  eventIdSelector,
  uuidSelector,
} from '../../store/selectors/profile.selectors';

declare let Processing: any;

@Injectable({
  providedIn: 'any',
})
export class ProcessingService {
  private uuid: string = '';

  private eventId: string = '';

  private email: string = '';

  onMounted: Subject<any> = new Subject<any>();

  onError: Subject<any> = new Subject<any>();

  onFail: Subject<any> = new Subject<any>();

  onSubmit: Subject<any> = new Subject<any>();

  onSuccess: Subject<any> = new Subject<any>();

  onVerify: Subject<any> = new Subject<any>();

  onCard: Subject<any> = new Subject<any>();

  onSessionExpired: Subject<any> = new Subject<any>();

  _products: any;

  private get products() {
    if (CookieService.getCookie('plan')) {
      this._products = JSON.parse(CookieService.getCookie('plan')!);
    }
    return this._products;
  }

  private readonly formEventListeners = {
    onMounted: (e: any) => {
      this.onMounted.next(e);
    },
    onError: (e: any) => {
      this.onError.next(e);
    },
    onFail: (e: any) => {
      this.onFail.next(e);
    },
    onSubmit: (e: any) => {
      this.onSubmit.next(e);
    },
    onSuccess: (e: any) => {
      this.onSuccess.next(e);
    },
    onVerify: (e: any) => {
      this.onVerify.next(e);
    },
    onCard: (e: any) => {
      this.onCard.next(e);
    },
    onSessionExpired: (e: any) => {
      this.onSessionExpired.next(e);
    },
  };

  constructor(private api: ApiService, private store: Store<AppStateInterface>) {
    combineLatest([
      this.store.select(uuidSelector),
      this.store.select(eventIdSelector),
      this.store.select(emailSelector),
    ]).subscribe(([uuid, eventId, email]) => {
      this.uuid = uuid;
      this.eventId = eventId;
      this.email = email;
    });
  }

  getProduct(except_subgroup = '') {
    return new Observable((subscriber) => {
      if (this.products) {
        if (this.products.before_timer.subgroup !== except_subgroup) {
          subscriber.next(this.products);
        } else {
          this.getProductRequest(except_subgroup).subscribe((response) => {
            subscriber.next(response);
          });
        }
      } else {
        this.getProductRequest(except_subgroup).subscribe((response) => {
          subscriber.next(response);
        });
      }
    });
  }

  checkOrderStatus(orderUuid: string) {
    const formData = new FormData();
    formData.append('order_uuid', orderUuid);
    return this.api.postProcessing2app('/api/intent/status', formData);
  }

  initPaymentForm(product_uuid: string, container_id: string) {
    Processing.Processing.initOptimalForm(
      {
        product_uuid: product_uuid,
        event_id: this.eventId,
        containerId: container_id,
        redirect_page: `${environment.appDomain}/success`,
        paypalContainerId: 'paypal-button',
        account_uuid: this.uuid,
        email: this.email,
        formParams: {
          submitButtonText: 'Pay',
          isCardHolderVisible: false,
          headerText: 'Enter your debit or credit card details (from merchant)',
          titleText: '',
          formTypeClass: 'flat',
          isSolidLogoVisible: false,
          googleFontLink:
            '//fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap',
          cardBrands: ['visa', 'mastercard', 'maestro', 'discover'],
          'font-family': 'Roboto',
        },
        styles: {
          form_body: {
            'min-width': 'unset',
          },
        },
        applePayButtonParams: {
          enabled: true,
          containerId: 'apple-button',
          color: 'white',
        },
      },
      this.formEventListeners,
    );
  }

  private getProductRequest(except_subgroup = '') {
    return this.api
      .postWeb2app('/payment/form/products', {
        event_id: this.eventId,
        except_subgroup: except_subgroup,
        landing_uuid: '0e490b81-e882-4d41-ab2b-b499bea665f2',
      })
      .pipe(
        map((response: any) => {
          if (response.status === 'success') {
            this._products = response.data.products;
            CookieService.setCookie('plan', JSON.stringify(response.data.products));
            return this._products;
          } else {
            return false;
          }
        }),
      );
  }
}
